import { Component ,OnInit  } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-partners-page',
  templateUrl: './partners-page.component.html',
  styleUrls: ['./partners-page.component.scss']
})
export class PartnersPageComponent implements OnInit {
  constructor(
    private titleService: Title,
   
  )
  {    }

  ngOnInit(){
    this.titleService.setTitle('Partners');
}
}
